export default {"src":"/_next/static/media/bank-jcb-square.c8d1d8cb.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};